import "./Methodology.module.css";
import YujuBranding from "@/reusable_sections/Header";
import HeroIntroduction from "./sections/HeroIntroduction";
import TechnicalAdvantages from "./sections/TechnicalAdvantages";
import ServiceAreas from "./sections/ServiceAreas";
import Features from "./sections/Features";
import BharatVidyaFooter from "@/reusable_sections/Footer";
export default function MethodologyPage() {
  return <div>
      <YujuBranding />
      <HeroIntroduction />
      <TechnicalAdvantages />
      <ServiceAreas />
      <Features />
      <BharatVidyaFooter />
    </div>;
}